import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';
import { lowHeightScreens } from 'components/common/fontElements';

export const Container = styled.div`
  display: flex;
  flex: 1 1 0;
  padding: 20px;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.baseBackground};

  @media (max-height: ${lowHeightScreens}) {
    padding: 50px 30px;
  }
`;

export const InfoWrapper = styled.div`
  padding: 0 30px;
`;

export const SelectedText = styled.div`
  margin-top: 15px;
  width: 256px;
  border-radius: 4px;
  border: 1px solid ${colors.blue1};
  padding: 11px 8px;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.67;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DateText = styled.div`
  padding-left: 4px;
  color: ${colors.blue1};
`;
